var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs2, _path35, _defs3, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 398.3 412.3",
    style: {
      enableBackground: "new 0 0 398.3 412.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000083060158835129807120000015707769975917294250_);}\n\t.st1{fill:#DFB398;}\n\t.st2{fill:#5C3B6B;}\n\t.st3{fill:#009365;}\n\t.st4{fill:#FAFAFA;}\n\t.st5{fill:#4D2D5C;}\n\t.st6{fill:#4B3728;}\n\t.st7{fill:#B2806D;}\n\t.st8{fill:#683931;}\n\t.st9{clip-path:url(#SVGID_00000166656822147385870010000010574988711278579337_);}\n\t.st10{fill:#DFD7D2;}\n\t.st11{clip-path:url(#SVGID_00000103262701537680168790000000222183656192027520_);}\n\t.st12{fill:#516961;}\n\t.st13{fill:#3E302A;}\n\t.st14{fill:#846250;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5401"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 398.3,
    height: 412.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152240692419808590580000008069680398582685884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5400",
    style: {
      clipPath: "url(#SVGID_00000152240692419808590580000008069680398582685884_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22172",
    className: "st1",
    d: "M127.7,298.5L127.7,298.5c9.2,2.4,18.6-3.2,20.9-12.4l33.8-91.1 c2.7-10.6-3.7-21.4-14.4-24.1c-10.6-2.7-21.4,3.7-24.1,14.4c-0.1,0.3-0.1,0.5-0.2,0.8l-28.5,91.4 C112.9,286.7,118.5,296.1,127.7,298.5C127.7,298.5,127.7,298.5,127.7,298.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22173",
    className: "st2",
    d: "M180.3,225.8l-47.8-12.2l7.1-27.7c6.2-24.2,30.8-38.8,55-32.6c0,0,0,0,0,0 c2.2,0.6,3.6,2.8,3,5.1L180.3,225.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22174",
    className: "st3",
    d: "M355.9,412.3l20.5-139.5l-63.3-66.1l-87.2,72.4L355.9,412.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22175",
    className: "st2",
    d: "M221.4,284.8c0,0,18.8,1.5,63.5-35.6c31.6-26.2,35.9-42.2,35.9-42.2l-40.1-86.4 c-9.6-19.7-27.3-25.9-45.7-13.9L160,155.5c-17.6,11.6-20.1,29.8-7.3,46.5L221.4,284.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22176",
    className: "st4",
    d: "M215.7,158.4c9.5-7.9,11.5-21.8,4.7-32.1c-0.2-0.2-0.5-0.3-0.7-0.1s-0.3,0.5-0.1,0.7 c7.2,10.7,4.3,25.1-6.3,32.3c-10.7,7.2-25.1,4.3-32.3-6.3c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.2-0.5-0.3-0.7-0.1 c-0.2,0.2-0.3,0.5-0.1,0.7c7.4,11.2,22.5,14.2,33.6,6.8c0,0,0,0,0,0C214.3,159.5,215,159,215.7,158.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22177",
    className: "st5",
    d: "M339.3,237.7c0.7-0.6,1.4-1.2,2-1.8c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.7,0 c-0.1,0.1-8.5,8.8-19.4,8.9c-6.3,0.1-12.3-2.7-17.8-8.3c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7 c5.7,5.8,11.9,8.6,18.5,8.6C329.3,245,336.1,240.3,339.3,237.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22178",
    className: "st5",
    d: "M295.4,275.4c0.2-0.1,0.2-0.4,0.1-0.6l-9.4-15.4c-0.3-0.5-1-0.7-1.5-0.4c0,0,0,0-0.1,0 l-8,5.7c-0.5,0.4-0.6,1-0.3,1.5c0,0.1,0.1,0.1,0.1,0.2l6.5,6.1c0.2,0.2,0.4,0.1,0.6,0c0.1-0.2,0.1-0.4,0-0.6l-6.5-6.1 c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0.1-0.2l8-5.7c0.1,0,0.1-0.1,0.2,0c0.1,0,0.1,0.1,0.2,0.1l9.4,15.4 C294.9,275.5,295.1,275.6,295.4,275.4L295.4,275.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22179",
    className: "st5",
    d: "M247.8,300.5C247.8,300.5,247.8,300.5,247.8,300.5c10.3-11.9,1.2-26.9,1.1-27.1 c-0.1-0.2-0.4-0.3-0.6-0.1c-0.2,0.1-0.2,0.4-0.1,0.6c0.1,0.1,8.9,14.7-1,26c-0.2,0.2-0.2,0.4,0,0.6 C247.3,300.7,247.6,300.7,247.8,300.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22180",
    className: "st4",
    d: "M146.2,211.5c0.3,0,0.5-0.3,0.4-0.5c0-0.2-0.2-0.4-0.4-0.4l-11.2-2.8 c-0.3-0.1-0.5,0.1-0.6,0.4c-0.1,0.3,0.1,0.5,0.3,0.6l11.2,2.8C146.1,211.5,146.1,211.5,146.2,211.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22181",
    className: "st4",
    d: "M193,251.1c0.2-0.2,0.2-0.5,0.1-0.7c0,0,0,0,0,0l-27-32.6c-0.2-0.2-0.5-0.2-0.7,0 c-0.2,0.2-0.2,0.4-0.1,0.6l27,32.6C192.5,251.3,192.8,251.3,193,251.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22182",
    className: "st1",
    d: "M25.2,262.1L25.2,262.1c-1.1,6,3.5,11.9,10.5,13.6l90.5,23.1c11.1,2,21.5-3.9,23.2-13.2 c1.7-9.3-5.9-18.6-17-20.6L39.6,253C32.5,252.3,26.2,256.2,25.2,262.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22183",
    className: "st1",
    d: "M44.9,257.2c-1.8-1.8-3.8-3.5-5.9-5.1c-2-1.5-4.1-2.9-6.3-4.1c-2.2-1.2-4.6-2.2-7-3 c-2.4-0.7-5-1-7.5-0.9c-0.7,0-1.3,0.7-1.2,1.4c0,0.6,0.4,1.1,1,1.2l0.1,0c4.2,1.1,7.6,3.7,10.6,6.7c1.5,1.6,2.8,3.2,4.1,5 c1.2,1.7,2.3,3.4,3.3,5.3c1.4,2.8,4.7,3.9,7.5,2.6c2.8-1.4,3.9-4.7,2.6-7.5c-0.3-0.5-0.6-1-1-1.4L44.9,257.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22184",
    className: "st1",
    d: "M37.2,267.2c-2.4-1.4-5.1-2.8-7.7-4.2c-2.6-1.3-5.3-2.6-8-3.7c-5.4-2.4-11-4.1-16.8-5.1 l-0.1,0c-1-0.1-1.7-1.1-1.5-2c0.1-0.9,0.8-1.5,1.7-1.6c6.3-0.2,12.6,0.3,18.8,1.7c3.1,0.6,6.1,1.3,9.1,2.1c3.1,0.8,6,1.7,9.1,2.7 c2.9,1,4.5,4.1,3.5,7s-4.1,4.5-7,3.5c0,0-0.1,0-0.1,0C37.9,267.6,37.6,267.4,37.2,267.2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22185",
    className: "st1",
    d: "M46.6,275.4c-2.7,0.1-5.5,0.2-8.2,0.4c-2.8,0.2-5.5,0.4-8.3,0.7 c-5.5,0.5-11,1.4-16.4,2.6h0c-1,0.2-1.9-0.4-2.1-1.4c-0.2-0.8,0.2-1.6,1-2c5.2-2.4,10.6-4.5,16.1-6.3c2.7-0.9,5.5-1.8,8.2-2.6 c2.8-0.8,5.5-1.6,8.4-2.3c3-0.8,6,1.1,6.8,4c0.8,3-1.1,6-4,6.8C47.4,275.4,47,275.4,46.6,275.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22186",
    className: "st1",
    d: "M32,272.7c-2-0.3-3.9-0.6-5.9-0.7c-2-0.1-4.1-0.2-6.2-0.1c-4.1,0.1-8.3,0.6-12.3,1.6 l-0.1,0c-1,0.3-2-0.3-2.2-1.3c-0.2-0.8,0.1-1.6,0.8-2c3.9-2.3,8.1-4.2,12.5-5.6c2.2-0.7,4.4-1.3,6.6-1.8c2.3-0.5,4.6-1,7-1.2 l0.1,0c3.1-0.3,5.8,1.9,6.2,4.9c0.3,3.1-1.9,5.8-4.9,6.2C33.1,272.8,32.5,272.8,32,272.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22187",
    className: "st1",
    d: "M32.6,266.4c-2.5-0.4-5.1-0.7-7.6-1c-2.5-0.3-5.1-0.5-7.7-0.7c-2.6-0.2-5.1-0.3-7.7-0.3 c-2.5-0.1-5,0.1-7.5,0.4l-0.1,0c-1,0.2-1.9-0.5-2.1-1.5c-0.1-0.8,0.3-1.6,1.1-2c2.6-1,5.2-1.8,7.9-2.4c2.6-0.6,5.3-1.1,7.9-1.6 c2.6-0.4,5.3-0.8,8-1.2c2.7-0.3,5.3-0.6,8-0.9h0c3.1-0.2,5.7,2.1,5.9,5.2c0.2,3-2,5.6-5,5.9C33.5,266.5,33,266.4,32.6,266.4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22188",
    className: "st1",
    d: "M381.3,151.8L381.3,151.8c-2.5,9.2-11.9,14.6-21.1,12.2l-103.1-15.9 c-10.6-2.9-16.8-13.8-13.9-24.3c2.9-10.6,13.8-16.8,24.3-13.9c0.3,0.1,0.5,0.1,0.8,0.2l100.8,20.6 C378.3,133.2,383.8,142.7,381.3,151.8C381.3,151.8,381.3,151.8,381.3,151.8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22189",
    className: "st2",
    d: "M294.3,162l12.8-47.7l-34.1-9.2c-20.5-5.5-41.7,6.7-47.2,27.2 c-1.6,5.8,1.9,11.8,7.7,13.3L294.3,162z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22190",
    className: "st4",
    d: "M286.8,160c0.1-0.1,0.1-0.1,0.2-0.2l12.4-44.9c0.1-0.3-0.1-0.5-0.4-0.6 c-0.2-0.1-0.5,0.1-0.6,0.3L286,159.5c-0.1,0.3,0.1,0.5,0.3,0.6c0,0,0,0,0,0C286.5,160.2,286.7,160.1,286.8,160"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22191",
    className: "st4",
    d: "M294.6,162.4l5.7-19.2c0.1-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.5,0.1-0.6,0.3l-5.4,18.4 l-20.9-5.6c-0.3-0.1-0.5,0.1-0.6,0.4c-0.1,0.2,0.1,0.5,0.3,0.6L294.6,162.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22192",
    className: "st1",
    d: "M368.5,28.1L368.5,28.1c-6,0.5-10.5,6.5-10.3,13.7l-3.7,102.8c1,11.3,9.5,19.7,19,18.9 s16.3-10.7,15.3-21.9l-7.8-101.9C379.9,32.6,374.5,27.6,368.5,28.1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22193",
    className: "st1",
    d: "M378.1,44.8c2.3-1.2,4.5-2.6,6.5-4.2c2-1.5,4-3.1,5.8-4.9c1.8-1.8,3.4-3.7,4.8-5.8 c1.4-2.1,2.4-4.5,3-7c0.2-0.7-0.3-1.4-1-1.6c-0.6-0.1-1.1,0.1-1.4,0.6l0,0.1c-2.2,3.7-5.7,6.3-9.5,8.2c-1.9,1-3.9,1.8-5.9,2.5 c-2,0.7-4,1.2-6,1.6c-3.1,0.5-5.1,3.4-4.6,6.5c0.5,3.1,3.4,5.1,6.5,4.6c0.6-0.1,1.1-0.3,1.7-0.6L378.1,44.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22194",
    className: "st1",
    d: "M370.7,34.5c2.1-1.9,4.2-4.1,6.2-6.2c2-2.2,4-4.4,5.9-6.6c3.8-4.4,7.1-9.4,9.7-14.6 l0-0.1c0.4-0.9,1.5-1.3,2.4-0.9c0.8,0.4,1.2,1.2,1,2.1c-1.6,6.1-3.9,12-7,17.6c-1.5,2.8-3,5.5-4.7,8.2c-1.7,2.7-3.3,5.3-5.2,7.9 c-1.8,2.5-5.3,3.1-7.8,1.3c-2.5-1.8-3.1-5.3-1.3-7.8C370.1,35.1,370.4,34.8,370.7,34.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22195",
    className: "st1",
    d: "M360.1,41.1c0.7-2.6,1.4-5.3,2-8c0.6-2.7,1.2-5.4,1.7-8.2c1.1-5.4,1.8-10.9,2.3-16.5v0 c0.1-1,0.9-1.8,1.9-1.7c0.8,0.1,1.5,0.7,1.7,1.5c0.8,5.7,1.3,11.5,1.4,17.2c0.1,2.9,0.1,5.7,0.1,8.6c0,2.9-0.1,5.7-0.2,8.7 c-0.1,3.1-2.7,5.4-5.8,5.3c-3.1-0.1-5.4-2.7-5.3-5.8C359.9,41.9,360,41.5,360.1,41.1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22196",
    className: "st1",
    d: "M367,27.9c0.9-1.8,1.7-3.6,2.3-5.5c0.7-1.9,1.3-3.9,1.9-5.9c1.1-4,1.8-8.1,2-12.3V4.3 c0-1,0.9-1.8,1.9-1.8c0.8,0,1.5,0.6,1.7,1.4c1.1,4.4,1.7,9,1.7,13.5c0,2.3,0,4.6-0.2,6.9c-0.1,2.4-0.4,4.7-0.8,7.1l0,0.1 c-0.6,3-3.5,5.1-6.5,4.5c-3-0.6-5.1-3.5-4.5-6.5l0,0C366.5,28.9,366.7,28.4,367,27.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22197",
    className: "st1",
    d: "M372.8,30.3c1.1-2.2,2.1-4.6,3.1-7c1-2.4,2-4.8,2.9-7.2c0.9-2.4,1.8-4.8,2.5-7.2 c0.8-2.4,1.3-4.8,1.7-7.3l0-0.1c0.1-1,1-1.7,2-1.6c0.8,0.1,1.5,0.8,1.6,1.6c0.2,2.7,0.3,5.5,0.1,8.3c-0.2,2.7-0.4,5.4-0.8,8.1 s-0.7,5.3-1.2,8c-0.4,2.7-0.9,5.2-1.5,8v0c-0.6,3-3.6,5-6.6,4.3c-3-0.6-5-3.6-4.3-6.6c0,0,0,0,0,0 C372.5,31.1,372.6,30.7,372.8,30.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22198",
    className: "st1",
    d: "M378.2,136.7c-5.9-7.1-16.5-8.1-23.7-2.2c-7.1,5.9-8.1,16.5-2.2,23.7 c5.9,7.1,16.5,8.1,23.7,2.2C383.1,154.5,384.1,143.8,378.2,136.7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22199",
    className: "st6",
    d: "M149.1,65.9c8-4.1,19.3-8.1,27.4-0.8c4.4-0.1,7.2,0.4,10.1,6 c1.8,3.6,10.4,21.6,10.4,21.6s-4.8,5-6.1,3.7c-4-4.1-12.3-7.7-14.2-9.7c-2-2.1,1-8.6-3.5-11.7c-6.1-4-13.1,6.6-23.6,12 c-4.1,2.1-5.9,19.6-10.4,20.3c-2.3,0.4-7.2-12.4-8-16.4C129.7,83.3,138.3,71.4,149.1,65.9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22200",
    className: "st1",
    d: "M211.2,156.3L211.2,156.3c9-5.8,10.9-19,4.1-29.5l-25.4-39.7 c-6.7-10.5-19.5-14.3-28.6-8.5c-9,5.8-10.9,19-4.1,29.5l25.4,39.7C189.4,158.3,202.2,162.1,211.2,156.3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22201",
    className: "st1",
    d: "M175.5,142.4c8.8-3.9,15.5-14.8,18.4-24.7c2.1-7.3,5.3-13.9,2.4-19.8l-8.5-14.1 c-6.8-13.9-21.3-20.1-36.5-12.6c-15.2,7.5-22.6,20.4-12.3,38.5c2.5,4.3,5.5,11.6,7.4,15.3c3.6,7.1,6.7,11.1,15.3,15.6 C167.7,143.8,171.9,144,175.5,142.4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22202",
    className: "st7",
    d: "M189.6,96.1c1.6,2.3,8.2,11.9-4.5,23c-0.9-0.8-2.1-2.1-3.2-3.2 c-1.5-1.4-10.5,0.6-14.8,2.7c-3.9,1.8-9.2,7.4-9.8,8.9c-0.5,1.5,0.4,3.9,1.4,5.8c0.5,1-7.4-0.4-7,0.1c2.2,2.9,15.1,15.4,28.3,8.7 c12.6-6.4,15.2-20.5,17.3-29.4c0.6-2.4,0.2-8.3-4-17.1C185.4,78.9,189.6,96.1,189.6,96.1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22203",
    className: "st1",
    d: "M169,120.9c1.4-0.7,9.4-3.9,11.1-2.3c1.3,1.2,7.4,10,1.7,13.5c-4.2,2.6-5.7-1.6-5.7-1.6 l-3.3,1.5c0,0,2.4,3.3-2.1,5.2c-4.7,2-10-8-10.1-8.4C160.4,126.4,167.1,121.8,169,120.9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22204",
    className: "st7",
    d: "M175.3,131.2c0.9-0.6,1.7-1.4,2.3-2.3c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1 c-1.5,2.3-4.3,3.7-6.6,3.3c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0,0,0c0,0.2,0.1,0.4,0.3,0.4C172.1,132.7,173.9,132.2,175.3,131.2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22205",
    className: "st8",
    d: "M178.4,120.3c0-0.3-0.1-0.5-0.4-0.5c-0.1,0-0.3,0-0.4,0.1c-2.4,1.6-4.9,3.1-7.5,4.5 c-3.1,1.6-5.6,2.6-6.9,3.1c-0.2,0.1-0.4,0.4-0.3,0.6c0,0.1,0.1,0.2,0.2,0.2c2.8,1.8,6.4,2,9.5,0.5 C176.7,126.8,178,122.4,178.4,120.3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5403",
    transform: "translate(163.699 120.38)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054951121496768055140000013969764389030527916_",
    d: "M12.9,0.2C10.8,1.5,8.7,2.8,6.5,4 C4.1,5.2,2,6.1,0.6,6.7C0.1,6.9-0.1,7.5,0.1,8c0.1,0.2,0.3,0.4,0.5,0.5c2.6,1.4,5.8,1.4,8.4,0c2.7-1.6,4.6-4.2,5.4-7.2 c0.2-0.5-0.1-1.1-0.6-1.3C13.5,0,13.2,0,12.9,0.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073695118918511497370000005440437562468535948_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054951121496768055140000013969764389030527916_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5402",
    style: {
      clipPath: "url(#SVGID_00000073695118918511497370000005440437562468535948_)"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22206",
    className: "st10",
    d: "M0,5.3c0.8,1.7,4.1,1.9,7.3,0.3s5-4.3,4.2-6S7.3-2.3,4.2-0.7S-0.9,3.6,0,5.3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5405"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000014619863503988246790000004348110223524603528_",
    y: 0,
    width: 398.3,
    height: 412.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081623308039324471970000009257682722019146118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014619863503988246790000004348110223524603528_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5404",
    style: {
      clipPath: "url(#SVGID_00000081623308039324471970000009257682722019146118_)"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22208",
    className: "st12",
    d: "M169,100.4c0.9-0.7,2.2-0.5,2.9,0.4c0.7,0.9,0.5,2.2-0.4,2.9s-2.2,0.5-2.9-0.4 c0,0,0,0,0,0C167.9,102.4,168.1,101.1,169,100.4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22209",
    className: "st13",
    d: "M172.6,96.2c0.1-0.1,0.2-0.2,0.2-0.3c0-0.3-0.2-0.5-0.4-0.6c-2.1-0.3-4.9,0.9-8.4,3.5 c-0.2,0.2-0.3,0.5-0.1,0.7c0.2,0.2,0.5,0.3,0.7,0.1c0,0,0,0,0,0c4-3.1,6.4-3.5,7.6-3.3C172.4,96.3,172.5,96.2,172.6,96.2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22210",
    className: "st12",
    d: "M151.4,109.3c-1.1,0.3-1.7,1.5-1.4,2.6c0.3,1.1,1.5,1.7,2.6,1.4s1.7-1.5,1.4-2.6 c0,0,0,0,0,0C153.7,109.6,152.5,109,151.4,109.3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22211",
    className: "st13",
    d: "M153.4,105.3c0.2-0.2,0.3-0.5,0.1-0.7c-0.1-0.2-0.3-0.2-0.5-0.2 c-4.2,1.2-6.8,2.8-7.8,4.7c-0.2,0.2-0.1,0.5,0.1,0.7s0.5,0.1,0.7-0.1c0,0,0-0.1,0-0.1c0.6-1.1,2.3-2.8,7.2-4.2 C153.4,105.4,153.4,105.3,153.4,105.3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22212",
    className: "st7",
    d: "M172.8,104.5c0,0,0.1-0.1,0.1-0.1c0.2-1,0.9-1.8,1.8-2.2c0.1,0,0.2-0.2,0.1-0.3 c0-0.1-0.2-0.2-0.3-0.1c-1.1,0.4-1.9,1.4-2.1,2.5c0,0.1,0,0.2,0.2,0.3c0,0,0,0,0,0C172.7,104.6,172.8,104.6,172.8,104.5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22213",
    className: "st7",
    d: "M152.2,114.8C152.2,114.8,152.3,114.7,152.2,114.8c0.1-0.2,0.1-0.3,0-0.4c0,0,0,0,0,0 c-1-0.4-2.2-0.3-3.1,0.4c-0.1,0.1-0.1,0.2,0,0.3c0,0,0,0,0,0c0.1,0.1,0.2,0.1,0.3,0c0,0,0,0,0,0c0.8-0.6,1.7-0.7,2.6-0.3 C152,114.8,152.1,114.8,152.2,114.8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22214",
    className: "st7",
    d: "M165.4,116.5c0.4-0.3,0.8-0.6,1.2-1c0.1-0.1,0.1-0.4,0-0.5c-0.1-0.1-0.4-0.1-0.5,0 c-0.8,1-2,1.6-3.3,1.6c-1-0.1-1.8-0.6-2.3-1.5c-1.5-2.3,0.2-4.1,1.8-5.4c0.1-0.1,0.2-0.3,0.1-0.4l-2.2-5.5 c-0.1-0.2-0.3-0.3-0.4-0.2c-0.2,0.1-0.3,0.3-0.2,0.4l2.1,5.3c-1.1,0.9-3.7,3.2-1.8,6.1c0.6,1,1.6,1.7,2.8,1.8 C163.7,117.3,164.7,117.1,165.4,116.5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22215",
    className: "st6",
    d: "M132.9,89.7c1.4,2.7,9.2,0,16-3.5c10.4-5.3,20.7-15,25.6-11.8 c3.8,2.5,9.2,11.7,15.1,21.7c0.9,1.6,5.7-6.2,5.7-6.2c-3.1-3.8-11.9-24.9-26.4-25.4c-14.4-0.5-21.9,4.2-27.3,9.4 S131.6,87,132.9,89.7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22216",
    className: "st14",
    d: "M152.5,84.3c-1.8-0.6-2.5-4.1-0.4-4.3c-1.9-1.2-6.2,2.2-4.2,4.8 c0.5,0.9,1.5,1.2,2.4,0.7c0,0,0,0,0,0C151,85.1,152.5,84.3,152.5,84.3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22217",
    className: "st14",
    d: "M146.8,87.2c-2.9-0.9-2.1-4.9,0-4.8c-1.6-1.5-5.8,0.6-4.2,3.7 C143.8,88.5,146.8,87.2,146.8,87.2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22218",
    className: "st14",
    d: "M147.3,81.5c-1.4-1.6,0.7-3.6,1.9-2.7c-0.4-2.1-3.5-1.9-3.9,0.5 C145,81.3,147.3,81.5,147.3,81.5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22219",
    className: "st14",
    d: "M143.4,87.7c-1.3,1-2.4-0.3-2.1-1.4c-0.8,0.3-1.2,1.1-0.9,1.9c0.2,0.6,0.7,1,1.3,1 C143.1,89.4,143.4,87.7,143.4,87.7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22220",
    className: "st1",
    d: "M192.9,98.5c1.5,3.8,5.8,5.6,9.6,4.1c0,0,0,0,0,0c3.7-1.8,5.3-6.2,3.6-9.9 c-1.5-3.8-5.8-5.6-9.6-4.1c0,0,0,0,0,0C192.8,90.4,191.2,94.8,192.9,98.5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22221",
    className: "st7",
    d: "M197.1,96.4c0.2-0.1,0.3-0.4,0.2-0.6c-0.4-1.5,0.6-3.1,2.1-3.5c0.7-0.2,1.6-0.1,2.2,0.3 c0.3,0.2,0.6,0.1,0.8-0.2s0.1-0.6-0.2-0.8c0,0,0,0-0.1,0c-2-1.1-4.5-0.4-5.6,1.5c-0.5,0.9-0.7,2-0.4,3c0.1,0.3,0.4,0.5,0.7,0.4 C197,96.5,197.1,96.5,197.1,96.4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22222",
    className: "st7",
    d: "M200.3,96c0.3-0.2,0.3-0.5,0.2-0.8c0-0.1-0.1-0.1-0.1-0.1c-1.3-0.9-3-0.7-4,0.5 c-0.2,0.2-0.2,0.6,0.1,0.8s0.6,0.2,0.8-0.1c0.6-0.7,1.7-0.9,2.4-0.3C199.8,96.1,200.1,96.1,200.3,96"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration3);
export default __webpack_public_path__ + "static/media/illustration_3.1c7a3e577f225e433334796f64eba73a.svg";
export { ForwardRef as ReactComponent };